import { useQuery } from '@tanstack/react-query';
import type { VisibilityReportResponse } from '@brand24-original/llm-types';
import { getSharedVisibilityReport } from '../../services/visibility-report/VisibilityReportService';
import { GET_SHARED_VISIBILITY_REPORT } from '../../query/visibility-report/keys';

export const useGetSharedVisibilityReport = (shareToken: string) => {
  return useQuery<VisibilityReportResponse>({
    queryKey: [GET_SHARED_VISIBILITY_REPORT, shareToken],
    queryFn: () => getSharedVisibilityReport(shareToken),
    enabled: !!shareToken,
    // Raport jest snapshotem — raz pobrany nie zmieni się już nigdy.
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
